import { render, staticRenderFns } from "./ExportDefault.vue?vue&type=template&id=0984552c&"
import script from "./ExportDefault.vue?vue&type=script&lang=js&"
export * from "./ExportDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports